import Head from 'next/head';
import Link from 'next/link';

export default function GetInvolved() {
  return (
    <>
      <Head>
        <title>Get Involved | York Round Table | #DoMore</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="mx-auto w-full max-w-screen-xl">
        <article className="mx-auto w-full max-w-screen-lg">
          <h1 className="text-4xl text-rt-orange text-center mb-10">Get Involved</h1>
          <div className="mx-auto w-full max-w-screen-md text-white">
            <p className="mb-4 text-2xl">
              If you want to have fun, gain new experiences, meet new people and give something back
              to the community, we&apos;d love for you to be a part of York Round Table. It&apos;s a
              good way to get to know others and make friends from all walks of life with a similar
              attitude.
            </p>
            <p className="mb-4">
              We meet up on the second Wednesday of every month, often for a pint in a pub in or
              around York, but arrange other types of events throughout the year too. The best way
              to decide whether Round Table is for you is to come along to our next event.
            </p>
            <p className="mb-4">
              We are always on the lookout for new members so if you think you would make a good
              Tabler,{' '}
              <Link href="/contact">
                <a className="underline hover:no-underline">get in touch with us</a>
              </Link>{' '}
              and let your Round Table journey begin.
            </p>
          </div>
        </article>
      </div>
    </>
  );
}
